import React, {Component} from 'react';
import {Editor} from '../editor-components';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import AffiliateList from '../affiliate-list/affiliate-list';

export default class AffiliateManagerDashboard extends Component {
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Affiliates</Tab>
          </TabList>
          <TabPanel>
            <AffiliateList />
          </TabPanel>
        </Tabs>
      </Editor>
    );
  }
}



// WEBPACK FOOTER //
// ./src/dashboard/affiliate-manager-dashboard.js